<template>
  <div>
  <body>
  <div class="disable-scroll-x">
    <div
      style="
        background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
      "
    >
      <CRow class="ml-5 mr-5 mb-5">
        <Mainlayout></Mainlayout>
        <br /><br /><br />
      </CRow>

      <CContainer>
        <div class="text-center d-sm-down-none">
          <h3 class="custom-64px text-white text-center">
            Download Pickiddo App
          </h3>
        </div>
      </CContainer>
      <CRow>
        <div class="card-custom-web" style="background: #fff">
            <CRow>
                <CCol sm="5">
                <div class="text-right">
                  <img
                    class="mt-5"
                    style="max-width: 100%"
                    src="../assets/img/icon/tab.png"
                  />
                </div>
              </CCol>
              <CCol sm="7" class="pr-5">
                <div class="mr-4">
                  <h3 class="text-center header-34px" style="margin-top: 10%">
                    <b>
                      Download Pickiddo Now Available <br />
                      on <span style="color: #007cef">All Platforms</span></b
                    >
                  </h3>
                  <CRow class="mt-3 mr-3">
                    <CCol sm="4">
                        <div class="text-center">
                      <img
                        style="max-width: 100%"
                        src="../assets/img/icon/Laptop.svg"
                      />
                      <br />
                    </div>
                      <div class="text-center">
                        <label class="subtitle-24px mt-4"> Desktop </label>
                        <br />
                        <label class="subtitle-16px"> Web Browser </label>
                      </div>
                    </CCol>
                    <CCol sm="4">
                     
                      <div class="text-center">
                        <img
                        style="max-width: 100%"
                        src="../assets/img/icon/tabphone.svg"
                      />
                      <br />
                        <label class="subtitle-24px mt-4">
                          Tablets & Mobiles
                        </label>
                        <br />
                        <label class="subtitle-16px"> Android & iPhone </label>
                      </div>
                    </CCol>
                    <CCol sm="4">
                     
                      <div class="text-center">
                        <img
                        style="max-width: 100%"
                        src="../assets/img/icon/smarttv.svg"
                      />
                      <br />
                        <label class="subtitle-24px mt-4"> Smart TV </label>
                        <br />
                        <label class="subtitle-16px"> Smart TV </label>
                      </div>
                    </CCol>
                    <CCol sm="6">
                      <div class="text-center p-2 mt-3">
                        <img
                          style="max-width: 100%"
                          src="../assets/img/icon/google.svg"
                        />
                      </div>
                    </CCol>
                    <CCol sm="6">
                      <div class="text-center p-2 mt-3">
                        <img
                          style="max-width: 100%"
                          src="../assets/img/icon/apple.svg"
                        />
                      </div>
                    </CCol>
                  </CRow>
                </div>
              </CCol>
            </CRow>
            <br />
            <h3 class="header-34px mt-5"><b>How to Sign Up</b></h3>
            <br />
            <CContainer>
            <CRow>
                <CCol sm="4">
                    <h3 class="header-34px mt-5"><b>Step 1</b></h3>
                   <h4 class="text-center">Click any two button on following below and start to download Pickiddo App</h4>
                   <br /><br />
                   <div class="text-center">
                    <a
                    href="https://play.google.com/store/apps/details?id=com.cellnet.pickiddo"
                  >
                    <img
                          style="max-width: 100%"
                          src="../assets/img/icon/google.svg"
                        />
                        </a>
                        <br /><br />
                        <a href="https://apps.apple.com/my/app/pickiddo/id1366167288">
                        <img
                          style="max-width: 100%"
                          src="../assets/img/icon/apple.svg"
                        />
                        </a>
                    </div>
                </CCol>
                <CCol sm="4">
                    <h3 class="header-34px mt-5"><b>Step 2</b></h3>
                    <h4 class="text-center">Click button <b>Sign Up</b></h4>
                    <br /><br />
                    <div class="text-center">
                    <img
                          style="max-width: 100%"
                          src="../assets/img/icon/step1.png"
                        />
                    </div>
                </CCol>
                <CCol sm="4">
                    <h3 class="header-34px mt-5"><b>Step 2</b></h3>
                    <h4 class="text-center">Fill Up the form on following below. Once done click Sign up and Start to Login</h4>
                    <div class="text-center">
                    <img
                          style="max-width: 100%"
                          src="../assets/img/icon/step2.png"
                        />
                    </div>
                </CCol>
            </CRow>
            </CContainer>
        </div>
      </CRow>
    </div>
    <Footerlayout></Footerlayout>
  </div>
</body>
</div>
</template>


    
<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import AnimatedNumber from "animated-number-vue";
import backgroundUrl from "../assets/img/bg3.png";
import VueMeta from "vue-meta";
Vue.use(VueMeta);

// import Translator from "vue-gtranslate";
// import "vue-gtranslate/translator.css";

Vue.use(require("vue-moment"));
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

import Mainlayout from "../containers/AllHeaderLanding.vue";
import Footerlayout from "../containers/TheFooter.vue";

import VueAgile from "vue-agile";
Vue.use(VueAgile);

// in component

import AOS from "aos";
import "aos/dist/aos.css";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import _ from "lodash";
import $ from "jquery";

import MenuIcon from "vue-material-design-icons/Menu.vue";
new Vue({
  el: "#navbar",

  data() {
    return {
      view: {
        topOfPage: true,
      },
    };
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.pageYOffset > 400) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
          el.setAttribute(
            "style",
            "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
          );
        }
      } else {
        if (!this.view.topOfPage) this.view.topOfPage = true;
        el.setAttribute(
          "style",
          "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
        );
      }
    },
  },
});
export default {
  metaInfo: {
    title: 'Download App - Enhance your childs learning and development with Pickiddo today. Available on both iOS and Android.',
    meta: [
      { property: 'og:title', content: 'Download App - Enhance your childs learning and development with Pickiddo today. Available on both iOS and Android.' }
    ],
    link: [
        { rel: 'canonical', href: 'https://www.pickiddo.com/DownloadApp' }
      ]
  },
  name: "Login",
  components: {
    Carousel3d,
    Slide,
    VueCal,
    MenuIcon,
    agile: VueAgile,
    Mainlayout,
    AnimatedNumber,
    backgroundUrl,
    Footerlayout,
  },
  data() {
    return {
    };
  },
  created() {
    AOS.init();
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    this.GetAllVideo();
    this.GetListVideoPopular();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {
    
  },

  methods: {
    ReloadButton() {
      window.open("https://www.pickiddo.com/home", "_self");
    },

    onScroll() {
      // Get the current scroll position
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return;
      }
      // Here we determine whether we need to show or hide the navbar
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition;
    },
    handleScroll() {
      if (window.pageYOffset > 1000) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
        } else {
          this.view.topOfPage = true;
        }
      }
    },
  },
};
</script>
        <style scoped>
    
    @import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
    @import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");
        
    .c-header {
      /* background: rgb(23, 77, 124);
      background: linear-gradient(92deg, #174d7c, #1b7682);
      border-bottom: 0.01px solid #1a6783;
      border-bottom: 1px solid #636f83; */
    
      background: transparent;
      border-bottom: 0;
      border-bottom: 0;
      /* color: #fff; */
    }
    .c-app{
      background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
      font-family: 'Montserrat', sans-serif;
    }
    body {
      font-family: "Montserrat", sans-serif;
      background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
    }
    h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
        margin-bottom: 0.5rem;
        font-weight: 500;
        line-height: 1.2;
        font-family: "Montserrat", sans-serif;
    }
    label
    {
      font-family: "Montserrat", sans-serif;
    }
    
    body nav.onScroll {
      box-shadow: 0 0 10px #aaa;
      background-color: rgb(255, 255, 255);
      font-family: 'Montserrat';
    font-style: normal;
    }
    body nav.onScroll ul li {
      color: #10b761;
    }
    body nav ul {
      margin-left: 3em;
      width: 25%;
      display: flex;
      justify-content: space-between;
    }
    body nav ul li {
      cursor: pointer;
      font-weight: 600;
      list-style-type: none;
      color: white;
    }
    body {
        top: 0 !important;
        font-family: 'Montserrat', sans-serif;
    }
        </style>